// opervex-frontend/src/layout/Header/Header.js

import React, { useEffect, useState } from "react";
import { Dropdown, Image, Spinner } from "react-bootstrap";
import { FiMenu, FiLogOut, FiKey } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

import useOpervex from "../../hooks/useOpervex";
import { useAuth } from "../../contexts/AuthContext";

const Header = ({ onToggleSidebar }) => {
  const { user, tenantId, logout } = useAuth();
  const OpervexAPI = useOpervex();
  const navigate = useNavigate();

  const [tenant, setTenant] = useState(null);
  const [loadingTenant, setLoadingTenant] = useState(true);

  useEffect(() => {
    if (!tenantId) {
      setLoadingTenant(false);
      return;
    }

    const loadTenant = async () => {
      try {
        setLoadingTenant(true);
        const data = await OpervexAPI.System.Tenant.findId();

        if (!data?.error) {
          setTenant(data);
        }
      } catch (err) {
        console.error("Erro ao carregar tenant:", err);
      } finally {
        setLoadingTenant(false);
      }
    };

    loadTenant();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId]);

  const handleLogout = () => {
    logout();
    navigate("/StartTenent");
  };

  const handleChangePassword = () => {
    navigate(`/${tenantId}/change-password`);
  };

  return (
    <header className="layout-header-modern">
      {/* Lado esquerdo */}
      <div className="header-left">
        <button className="sidebar-toggle-btn" onClick={onToggleSidebar}>
          <FiMenu size={22} />
        </button>

        <div className="header-brand">
          <img src="/logo_sem_fundo.png" alt="Opervex" width="32" />
          <span>Opervex</span>
        </div>
      </div>

      {/* Lado direito */}
      <div className="header-right">
        {loadingTenant ? <Spinner animation="border" size="sm" /> : <span className="tenant-name">{tenant?.name}</span>}

        <Dropdown align="end">
          <Dropdown.Toggle as="div" className="user-dropdown-toggle">
            <Image src={user?.avatar || "/default-avatar.png"} roundedCircle width="36" height="36" />
            <div className="user-info">
              <span className="user-name">{user?.fullname}</span>
              <span className="user-role">{user?.administrator ? "Administrador" : "Usuário"}</span>
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu className="user-dropdown-menu">
            <Dropdown.Item onClick={handleChangePassword} hidden>
              <FiKey className="me-2" />
              Alterar Senha
            </Dropdown.Item>

            <Dropdown.Divider />

            <Dropdown.Item onClick={handleLogout}>
              <FiLogOut className="me-2" />
              Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </header>
  );
};

export default Header;
